
class TinySlider {
  constructor(element, ...options) {
    this.defaults = {
      container: '.js-tiny-slider',
      mode: 'carousel',
      speed: 700,
      autoplay: false,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
      autoplayHoverPause: false,
      lazyload: false,
      animateIn: 'animate-in',
      animateOut: 'animate-out',
      animateNormal: 'animate-normal',
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.options.container = this.element;

    if(this.options.controlsContainer) {
      this.options.controlsContainer = this.element.closest('section').querySelector(this.options.controlsContainer);
    }

    if (this.options.autoplay) {
      this.autoplay = true;
      this.running = true;
    }

    this.sliderObject = tns(this.options);
    this.bindEvents();
  }

  play() {
    this.running = true;
    this.sliderObject.play();
    this.sliderObject.getInfo().navContainer.classList.remove('is-paused');
  }

  pause() {
    this.running = false;
    this.sliderObject.pause();
    this.sliderObject.getInfo().navContainer.classList.add('is-paused');
  }

  checkViewport() {
    if (isElementInViewport(this.element.parentNode, 0.25, true)) {
      if (!this.running) {
        this.play();
      }
    } else {
      if (this.running) {
        this.pause();
      }
    }

    window.requestAnimationFrame(this.checkViewport.bind(this));
  }

  startVideo(currentSlide) {
    let videoElement = currentSlide.querySelector('video');
    if(videoElement) videoElement.play();
  }

  pauseVideo(currentSlide) {
    let videoElement = currentSlide.querySelector('video');
    if(videoElement) videoElement.pause();
  }

  newSlide(info) {
    this.startVideo(info.slideItems.item(info.index));
  }

  slideChange(info) {
    this.pauseVideo(info.slideItems.item(info.index));
  }

  goToSlide(event) {
    const target = event.currentTarget;
    if(!target.classList.contains('tns-slide-active')) {
      const slidesArray = [].slice.call(this.sliderObject.getInfo().slideItems);
      this.sliderObject.goTo(slidesArray.indexOf(target));
    }
  }

  bindEvents() {
    if(this.sliderObject) {
      this.sliderObject.events.on('transitionEnd', this.newSlide.bind(this));
      this.sliderObject.events.on('transitionStart', this.slideChange.bind(this));
      if (this.autoplay) {
        window.requestAnimationFrame(this.checkViewport.bind(this));
      }

      if (this.options.clickableSlides) {
        let sliderItems = this.sliderObject.getInfo().slideItems;
        for(let i = 0; i < sliderItems.length; i++) {
          sliderItems[i].addEventListener('click', this.goToSlide.bind(this));
        }
      }
    }
  }
}
